import { connect } from 'react-redux'
import Sidebar from './../../../../common/containers/Sidebar'
import Card from './../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import CheckInitializePendingList from './CheckInitializePendingList'
import { useState } from 'react'
import CheckInitializeFinishedList from './CheckInitializeFinishedList'

let CheckInitializePage = () => {
    const [pageAttr, setPageAttr] = useState({})

    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/' element={<CheckInitializePendingList setPageAttr={setPageAttr} />} />
                    <Route path='/finished' element={<CheckInitializeFinishedList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(CheckInitializePage)